/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '~/lib/api/axiosClient';
import type {
  DevolverCompromissoHandleMutationRequest,
  DevolverCompromissoHandleMutationResponse,
} from '../../types/DevolverCompromissoHandle.ts';
import type { RequestConfig, ResponseErrorConfig } from '~/lib/api/axiosClient';

function getDevolverCompromissoHandleUrl() {
  const res = {
    method: 'POST',
    url: `/compromissos/devolver-compromisso` as const,
  };
  return res;
}

/**
 * {@link /compromissos/devolver-compromisso}
 */
export async function devolverCompromissoHandle(
  data?: DevolverCompromissoHandleMutationRequest,
  config: Partial<RequestConfig<DevolverCompromissoHandleMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    DevolverCompromissoHandleMutationResponse,
    ResponseErrorConfig<Error>,
    DevolverCompromissoHandleMutationRequest
  >({
    method: 'POST',
    url: getDevolverCompromissoHandleUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
